import { render, staticRenderFns } from "./SettingsMainMedia.vue?vue&type=template&id=1c76c1a8&"
import script from "./SettingsMainMedia.vue?vue&type=script&lang=js&"
export * from "./SettingsMainMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports